module.exports = __webpack_public_path__ + "static/media/daisy-ridley.09208876.jpg";